/**
 * Labels for a Vacancy's "Raises and Bonuses" section
 */
export enum RaisesAndBonuses {
  YearlySalaryIncrease = 'Salary increase',
  YearlyBonus = 'Bonus depending on company performance',
  AchievementBasedBonus = 'Achievement Based Bonuses',
  IndividualIncentives = 'Individual incentives'
}
